import { Injectable } from "@angular/core";
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from "@ngx-translate/core";

/**
 * This service will show you for your currently active language which translation keys are missing
 * You have to navigate through the pages to see the missing keys via console
 */
@Injectable({
  providedIn: "root",
})
export class MissingTranslationHandlerService
  implements MissingTranslationHandler
{
  constructor() {}

  public handle(params: MissingTranslationHandlerParams): string {
    /*
    Reasons why you're seeing the "Missing key message":
    The translation key doesn't exist for your selected language --> Please add them in this case
    Example: "Missing key: audio_devices.not_found"

    Or: The Key is translated twice and shows the actual translation as a key --> This means that there was something
      wrongly implemented and needs to be changed in the code but the actual translation key is available
    Example: "Missing key: Subscribe to a conference room"
    */
    // this.logger.error(
    //   "Translation missing or multiple translations provided for one key. Key:",
    //   params.key
    // );

    /*
    We show last chuck of missing translationKey split it by DOT(.)
    Example: translationKey is settings.extension.device_list.XYZ, So user will only see XYZ
      In console you will see the exact location of missing translationKey like 'settings.extension.device_list.XYZ'
    */
    return params.key.split(".").pop() as string;
  }
}
